export const PHONE_PREFIX_COUNTRY_CANADA = 'ca';

const PHONE_PREFIX_DATA = [

  [
    'Canada',
    PHONE_PREFIX_COUNTRY_CANADA,
    '+1',
    10
  ],
  [
    'Ireland',
    'ie',
    '+353',
    9
  ],
  [
    'United Kingdom',
    'gb',
    '+44',
    10
  ],
  // this must stay as last element in order to cover for countries without a specific prefix
  // useEffect on SignUp
  [
    'Others',
    '-',
    'Others',
    [6, 13]
  ]
];

export default PHONE_PREFIX_DATA;
